import { api } from './axios';

function normalizeApiPath(rawPath: string): string {
  const path = rawPath.trim();
  if (!path) throw new Error('Caminho de arquivo inválido');

  if (/^https?:\/\//i.test(path)) {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/api/')) {
      throw new Error('Download externo não permitido');
    }
    return `${url.pathname.slice(4)}${url.search}`;
  }

  if (path.startsWith('/api/')) return path.slice(4);
  throw new Error('Caminho de arquivo inválido');
}

async function requestAuthenticatedBlob(path: string): Promise<Blob> {
  const response = await api.get<Blob>(normalizeApiPath(path), { responseType: 'blob' });
  return response.data;
}

export async function openAuthenticatedFile(path: string): Promise<void> {
  const preview = window.open('', '_blank');
  if (preview) preview.opener = null;
  try {
    const blob = await requestAuthenticatedBlob(path);
    const objectUrl = URL.createObjectURL(blob);
    if (preview) {
      preview.location.href = objectUrl;
    } else {
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      anchor.click();
    }
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
  } catch (error) {
    preview?.close();
    throw error;
  }
}

export async function downloadAuthenticatedFile(path: string, fileName: string): Promise<void> {
  const blob = await requestAuthenticatedBlob(path);
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
}

export async function getAuthenticatedObjectUrl(path: string): Promise<string> {
  return URL.createObjectURL(await requestAuthenticatedBlob(path));
}
